// Haptic tick for tappables on the phone build.
//
// Android Chrome: navigator.vibrate(10) is the real API. iOS Safari has
// no vibration API, but since 17.4 an `<input type="checkbox" switch>`
// plays the system toggle haptic when flipped VIA ITS ASSOCIATED LABEL.
// Ported from Armarium's haptics.ts, whose comments record the traps:
//   - the input and label must be SIBLINGS linked by htmlFor; clicking a
//     label with the input nested inside toggles silently
//   - both elements must be rendered (1px, opacity 0, NOT display:none)
//   - since iOS 18.4 the programmatic click only ticks in the wake of a
//     real user gesture (our delegate fires on pointerdown, so it is)
//   - iOS 26.5 closed the trick entirely; there it stays silent and
//     nothing can be done short of a native wrapper
let label = null;

const SWITCH_ID = 'haptic-switch';

function getLabel() {
  if (label !== null && document.body.contains(label)) return label;

  const input = document.createElement('input');
  input.type = 'checkbox';
  input.setAttribute('switch', '');
  input.id = SWITCH_ID;
  input.tabIndex = -1;
  input.setAttribute('aria-hidden', 'true');

  const l = document.createElement('label');
  l.htmlFor = SWITCH_ID;
  l.setAttribute('aria-hidden', 'true');

  for (const el of [input, l]) {
    el.style.position = 'fixed';
    el.style.bottom = '0';
    el.style.left = '0';
    el.style.width = '1px';
    el.style.height = '1px';
    el.style.opacity = '0';
    el.style.pointerEvents = 'none';
  }

  document.body.append(input, l);
  label = l;
  return l;
}

// Throttled so a press that fires multiple events (pointerdown plus a
// synthetic click) reads as one tick, not a stutter.
let lastTick = 0;

export function hapticTick() {
  const now = Date.now();
  if (now - lastTick < 50) return;
  lastTick = now;
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function' && navigator.vibrate(10)) return;
  } catch {
    // fall through to the switch
  }
  try {
    getLabel().click();
  } catch {
    // Haptics are garnish; never let them throw.
  }
}
